import React from 'react';
import { PartyTypes } from 'vdlib';
import LookupsHelper from './LookupsHelper';

const usePartyFlags = (user, partyTypes, partyTypeMember = 'PartyType') => {
  const { isExpert, isInsurance, isMerchant, isOperator, partyType } =
    React.useMemo(() => {
      if (!partyTypes || !user) return {};
      const partyType = LookupsHelper.getDescription(
        partyTypes,
        user[partyTypeMember]
      );
      return {
        isExpert: partyType === PartyTypes.Expert,
        isInsurance: partyType === PartyTypes.Insurance,
        isMerchant: partyType === PartyTypes.Merchant,
        isOperator:
          partyType === PartyTypes.Operator ||
          partyType === PartyTypes.Admin_Insurance,
        partyType,
      };
    }, [partyTypes, user, partyTypeMember]);

  return {
    isExpert,
    isInsurance,
    isMerchant,
    isOperator,
    partyType,
  };
};

const useColumnDefsKey = (partyTypeDescription, auctionStatus) => {
  const columnDefsKey = React.useMemo(
    () => `${partyTypeDescription}_${auctionStatus}`,
    [auctionStatus, partyTypeDescription]
  );

  return columnDefsKey;
};

const usePartyFlagsAndColumnDefsKey = (user, partyTypes, auctionStatus) => {
  const { isExpert, isInsurance, isMerchant, isOperator, partyType } =
    usePartyFlags(user, partyTypes);

  const columnDefsKey = useColumnDefsKey(
    partyType,
    auctionStatus ? auctionStatus : isMerchant ? 'Participate' : null
  );

  return {
    isExpert,
    isInsurance,
    isMerchant,
    isOperator,
    partyType,
    columnDefsKey,
  };
};

export { usePartyFlags, useColumnDefsKey, usePartyFlagsAndColumnDefsKey };
